import React from "react"
import { useSelector } from "react-redux"

import { MtUser } from "server/models"
import { StoreType } from "client/store"
import {
    UserIcon,
    TableColumn,
} from "client/components"

const Columns = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
        },
        {
            field: "firstName",
            header: lang.name,
            sortable: true,
            cellMinWidth: "150px",
            formatter: (user: MtUser) => <UserIcon user={user} size="sm" />,
        },
        {
            field: "status",
            header: lang.status,
            centerAlign: true,
            sortable: true,
            editAccess: () => false,
        },
        {
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        },
    ]

    return columns
}
export default Columns
